import { render, staticRenderFns } from "./otherAccount.vue?vue&type=template&id=2b48f52f&scoped=true"
import script from "./otherAccount.vue?vue&type=script&lang=js"
export * from "./otherAccount.vue?vue&type=script&lang=js"
import style0 from "./otherAccount.vue?vue&type=style&index=0&id=2b48f52f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48f52f",
  null
  
)

export default component.exports